import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { MetaService } from '../services/meta.service'; // Your existing MetaService
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MetaGuard implements CanActivate {
  constructor(private metaService: MetaService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    this.setDefaultMetadata();
    return true;
  }

  private setDefaultMetadata(): void {
    const metadata = {
      title: 'ImageBase.pro – Stunning Stock Images for Creative Projects',
      description:
        'Explore a vast collection of high-resolution stock images. Download professional photos for business, design, and marketing needs.',
      keywords:
        'stock images, high-quality photos, stock photography, professional images, royalty-free pictures, commercial photos, high-resolution images',
    };
    this.metaService.setMetadata(metadata);
  }
}
